import { render, staticRenderFns } from "./DeviceHome.vue?vue&type=template&id=2af56584&scoped=true"
import script from "./DeviceHome.vue?vue&type=script&lang=js"
export * from "./DeviceHome.vue?vue&type=script&lang=js"
import style0 from "./DeviceHome.vue?vue&type=style&index=0&id=2af56584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af56584",
  null
  
)

export default component.exports